export function mapErrorToMessage(error: string): string|undefined {
    if (!error) return;
    for (const key of Object.keys(errorMap)) {
        if (error.includes(key)) {
            return errorMap[key as keyof typeof errorMap];
        }
    }
    return;
}

const errorMap = {
    ContentPolicyViolationError: "errorMessages.azureAiContentViolation",
};
